"use client";
import * as React from "react";
const SvgBoltFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.597 16h-.9l.9-6.222H.447c-.522 0-.513-.285-.342-.587.17-.302.045-.071.063-.107C1.328 7.058 3.075 4.036 5.397 0h.9l-.9 6.222h3.15c.44 0 .504.294.423.454l-.063.133C5.36 12.933 3.597 16 3.597 16Z" }));
export {
  SvgBoltFilled as default
};
